"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const getNavItemAriaLabel = ({ isDisabled, isSelected, text }) => {
    if (isDisabled) {
        return `${text}, disabled`;
    }
    if (isSelected) {
        return `${text}, selected`;
    }
    return text;
};
exports.default = getNavItemAriaLabel;
